import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { EmployeeDetails } from "components/User";
import EmployeeCourses from "components/Employee/EmployeeCourses";
import { userHasRight } from "selectors/rights";
import { EMPLOYEE_COURSE_VIEW, MANAGEMENT_CALENDAR_EDIT } from "typeConstants/rights";
import MCard from "components/Shared/MCard.tsx";
import MGridLayout from "components/Shared/MGridLayout";
import EmployeeCalendar from "components/Employee/EmployeeCalendar.tsx";
import LinkedUsersCard from "components/User/LinkedUser.tsx";

const EmployeeProfile = props => {

  const rows = [
    // Row 1: Employee Details, Courses (conditional), Calendar, Linked Users
    [
      { component: <EmployeeDetails employeeId={props.employeeId} />, size: 4 },
      ...(props.canViewEmployeeCourses ? [{ component: <EmployeeCourses employeeId={props.employeeId} />, size: 4 }] : []),
      {
        component: (
          <MCard
            title="Employee Calendar"
            fields={[{ 
              key: "calendar", 
              control: (
                <EmployeeCalendar 
                  employeeId={props.employeeId}
                  readOnly={props.canEditEmployeeCalendar ? false: true}
                  allowManagementEdit={props.canEditEmployeeCalendar}
                />)
            }]}
          />
        ),
        size: 4,
      },
      {
        component: (
          <LinkedUsersCard
            employeeInternetUserId={props.internetUserId}
            employeeId={props.employeeId}
          />
        ),
        size: 4,
      },
    ],
  ];

  return (
    <MGridLayout
      verticalDisplay={props.verticalDisplay}
      rows={rows}
      padding={props.verticalDisplay ? 0 : 1}
    />
  );
};

EmployeeProfile.propTypes = {
  employeeId: PropTypes.number,
  verticalDisplay: PropTypes.bool,
  canViewEmployeeCourses: PropTypes.bool.isRequired,
  canEditEmployeeCalendar: PropTypes.bool.isRequired,
  internetUserId: PropTypes.number,
};

const mapStateToProps = state => {
  return {
    canViewEmployeeCourses: userHasRight(EMPLOYEE_COURSE_VIEW)(state),
    canEditEmployeeCalendar: userHasRight(MANAGEMENT_CALENDAR_EDIT)(state),
  };
};

export default connect(mapStateToProps)(EmployeeProfile);
